import type { PropsWithChildren } from "react";

export function FieldLabel(props: PropsWithChildren) {
  return <div className="field-label">{props.children}</div>;
}
